"use Client";
import { useState } from "react";
import {
  close,
  widgetActionSummary,
  widgetPrice,
  widgetTradeCreation,
  widgetTradeTile,
} from "../icons/SVGIcons";
import { Button } from "../UI/Button";

interface INotificationCardProps {
  widget: string;
  message: string;
  timestamp: string;
  id: number;
  deleteNotification: Function;
}

const getIcon = (widget: string) => {
  let icon;
  switch (widget) {
    case "Action Summary":
      icon = widgetActionSummary;
      break;
    case "Trade Creation":
      icon = widgetTradeCreation;
      break;
    case "Trade Tile":
      icon = widgetTradeTile;
      break;
    case "Prices":
      icon = widgetPrice;
      break;
    // case "Analytics":
    //   icon = widgetAnalytics;
    //   break;
  }
  return icon;
};

function NotificationsCard({
  widget,
  message,
  timestamp,
  id,
  deleteNotification,
}: INotificationCardProps) {
  const [showNotifications] = useState(true);
  return (
    <div className="flex items-center justify-center">
      <div className="pointer-events-auto w-80 max-w-full rounded border bg-clip-padding text-sm shadow-md dark:border-black">
        <div
          // onClick={() => setShowNotifications(!showNotifications)}
          className="flex w-full items-center rounded-t border-b-2 bg-gray-100 bg-clip-padding px-3 py-2 text-gray-500 dark:border-black dark:bg-[#323232] dark:text-white"
        >
          <div className="h-4 w-4">{getIcon(widget)}</div>
          <strong className="mr-auto">{widget}</strong>
          <Button
            variant={"exit"}
            onClick={() => deleteNotification(id)}
            size={"icon_sm"}
          >
            {close}
          </Button>
        </div>
        <div className={`${showNotifications == true ? "visible" : "hidden"}`}>
          <div className="flex flex-row justify-between border-b-2 bg-white p-3 text-black dark:border-black dark:bg-black dark:text-white">
            <div>{message}</div>
            <div className="flex flex-row text-xs text-gray-500">
              <div>{timestamp}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationsCard;
